import { useNavigate } from "@tanstack/react-router";
import type { ReactNode } from "react";

import { rudderAnalytics, HotelTrackingEvents } from "@/app/lib/rudderstack";
import type { FindHotelsOutputData } from "@/app/lib/types/codegen";
import { HotelCard } from "@/features/hotels/components/hotels-list/HotelCard";
import { useOptionalHotelDataContext } from "@/features/hotels/contexts/HotelDataContext";

export function HotelCardList({
  hotels,
  bottomSlot,
}: {
  hotels: FindHotelsOutputData[] | undefined;
  bottomSlot?: ReactNode;
}) {
  const navigate = useNavigate();
  const { setData: setHotelData } = useOptionalHotelDataContext();

  const handleOverviewOpen = (hotel: FindHotelsOutputData) => {
    rudderAnalytics.track(HotelTrackingEvents.USER_ENTERED_PARTICULAR_OFFER, {
      offer_id: hotel.id,
      offer_type: "Hotel",
      price: hotel.minPrice?.value,
    });
    setHotelData(hotel);
    navigate({
      to: "/hotels/$id/details",
      params: { id: hotel.id },
    });
  };

  return (
    <ul className="space-y-2">
      {hotels?.map((hotel) => (
        <li key={hotel.id}>
          <HotelCard onClick={() => handleOverviewOpen(hotel)} hotel={hotel} />
        </li>
      ))}

      {bottomSlot}
    </ul>
  );
}
